import React from "react";
import "./Footer.css";
import logoImage from "../images/logo.png";
import {AiFillFacebook} from 'react-icons/ai';
import {ImTwitter} from 'react-icons/im';
// import {HiOutlineMail} from 'react-icons/hi';


export const Footer = () => {
	return (
		<div className="footer">
			
				<div className="footer-logo">
          <img className="logo" src={logoImage} alt ="logo"></img>
	      </div>

					
						{/* <h4 className="contact"><a href="https://www.facebook.com/bmdbrum/"><HiOutlineMail size={35}/></a></h4> */}
						<h4 className="contact"><a href="https://www.facebook.com/bmdbrum/"><AiFillFacebook size={35}/></a></h4>
						<h4 className="contact"><a href="https://twitter.com/bikemandanb13?lang=en"><ImTwitter size={35}/></a></h4>
				
			
		</div>
		
	);
};

